import { Form } from "../Support/Form";
import { axios } from "../Support/axios";

export class ReportSchedule extends Form {

    constructor(reports, data = {}) {
        super(data);

        this.reports = reports;
        this.report_structure = false;
        this.report_parameters = {};
        this.schedule_freqencies = false;
    }

    index(append = false) {
        return this.loadIndexData('/retail/report/schedule', append);
    }

    hasRenderFields() {
        let self = this;

        // Set the default export driver (CSV)
        self.report_parameters['export_driver'] = 'MBLSolutions\\Report\\Driver\\QueuedExport\\CsvQueuedExport';

        if (self.report_structure) {
            self.report_structure.fields.forEach(function (field) {
                self.report_parameters[field.alias] = null;
            });

            return self.report_structure.fields.length > 0;
        }

        return false;
    }

    reportSelected() {
        return this.data.report_id && this.report_structure;
    }

    showReport(renderFields = false) {
        let self = this;

        return new Promise((resolve, reject) => {
            axios.get(this.api_prefix + '/report/' + self.data.report_id, self.data)
                .then(response => {
                    self.report_structure = response.data.data;

                    if (renderFields) {
                        this.hasRenderFields();
                    }

                    resolve(true);
                }).catch(error => {
                    reject(error);
                });
        });
    }

    getScheduleFrequencies() {
        let self = this;

        return new Promise((resolve, reject) => {
            axios.get(this.api_prefix + '/report/schedule/frequency', self.data)
                .then(response => {
                    self.schedule_freqencies = response.data;

                    resolve(true);
                }).catch(error => {
                    reject(error);
                });
        });
    }

    createScheduledReport() {
        let self = this;

        self.data.parameters = self.report_parameters;

        return new Promise((resolve, reject) => {
            axios.post(this.api_prefix + '/retail/report/schedule', self.data)
                .then(response => {
                    resolve(true);
                }).catch(error => {
                self.setError(error);
                    reject(error);
                });
        });
    }

    showScheduledReport(uuid) {
        let self = this;

        return new Promise((resolve, reject) => {
            axios.get(this.api_prefix + '/report/schedule/' + uuid)
                .then(response => {
                    self.data = response.data.data;

                    self.showReport().then(r => {
                        self.report_parameters = self.data.parameters;

                        resolve(true);
                    });
                }).catch(error => {
                reject(error);
            });
        });
    }

    updateScheduledReport(uuid) {
        let self = this;

        self.data.parameters = self.report_parameters;

        return new Promise((resolve, reject) => {
            axios.patch(this.api_prefix + '/report/schedule/' + uuid, self.data)
                .then(response => {
                    resolve(true);
                }).catch(error => {
                self.setError(error);
                reject(error);
            });
        });
    }

    deleteScheduledReport(id) {
        let self = this;

        return new Promise((resolve, reject) => {
            axios.delete(this.api_prefix + '/report/schedule/' + id)
                .then(response => {
                    resolve(true);
                }).catch(error => {
                self.setError(error);
                reject(error);
            });
        });
    }

}
